import React, { useState } from "react";
import { useRef } from "react";
import {
  makeStyles,
  Theme,
  createStyles,
  withStyles,
} from "@material-ui/core/styles";
import { connect } from "react-redux";
import { Button, Paper, TextField, Grid } from "@material-ui/core";

import { useEffect } from "react";
import {
  getCenterInfo,
  createUsers,
  getCentreUsers,
} from "../../actions/GenomicsAdminAction";

import { useHistory } from "react-router-dom";
import Loader from "../../Components/loader/index";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { TableFooter, TablePagination } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";

// import "./index.sass";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    table: {
      minWidth: 700,
    },
    toolbar: {
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
    },
    content: {
      width: "80%",
      flexGrow: 21,
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    paper: {
      marginTop: "2rem",
      padding: "0.5rem 2rem 2rem 2rem",
      width: "100%",
    },
    contentHeader: {
      width: "100%",
      padding: "0px 10px 40px 10px",
      minHeight: "64px",
    },
    leftContentHeader: {
      width: "50%",
      float: "left",
    },
    rightContentHeader: {
      width: "50%",
      float: "right",
      textAlign: "right",
      paddingRight: "20px",
    },
    buttonContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    head: {
      textAlign: "center",
      fontWeight: "normal",
      marginBottom: "2rem",
    },
    slotContainer: {
      width: "100%",
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "center",
    },
    slot: {
      width: "150px",
      height: "100px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      margin: "0.5rem",
    },
    hoveItem: {
      cursor: "pointer",
    },
    selectedSlot: {
      width: "150px",
      height: "100px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(60deg, cyan, #00dfff, cyan)",
      cursor: "pointer",
      margin: "0.5rem",
    },
    chips: {
      display: "flex",
    },
    chip: {
      margin: 2,
      background: "linear-gradient(60deg, cyan, #00cfff, cyan)",
      maxWidth: "130px",
    },
    input: {
      padding: "1px",
    },
    tableContainer: {
      marginTop: "2rem",
      position: "sticky",
      top: "200px",
    },
  })
);

const StyledTableCell:any = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: "#924A91",
      color: theme.palette.common.white,
      fontSize: "14px",
    },
    body: {
      fontSize: 14,
    },
  })
)(TableCell);

const StyledTableRow:any = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);
interface Props {
  getCentreUsers: any;
  centreUsersData: any;
  getCenterInfo: any;
  centerInfo: any;
  createUsers: any;
  loading: any;
}
const CreateUsers: React.FC<Props> = ({
  getCentreUsers,
  centreUsersData,
  getCenterInfo,
  centerInfo,
  createUsers,
  loading,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const timer = useRef<any>(0);
  //create
  const [lab, setLab] = React.useState<any>("");
  const [labDetail, setLabDetails] = React.useState<any>("");
  const [orgCode, setOrgCode] = useState<any>("");
  const [empId, setEmpId] = useState<any>("");
  const [name, setName] = useState<any>("");
  const [email, setEmail] = useState<any>("");
  const [phoneNo, setPhoneNo] = useState<any>("");
  const [mobileValidation, setMobileValidation] = useState({
    phoneNo: true,
  });
  const [centre, setCentre] = useState<any>("");

  const [centreName, setCentreName] = useState<any>("");

  const [page, setPage] = useState(0);
  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (newPage > page) {
      let url =
        centreUsersData.links && centreUsersData.links.next.split("?")[1];
      getCentreUsers(`?${url}`);
    } else if (newPage < page) {
      let url =
        centreUsersData.links && centreUsersData.links.previous.split("?")[1];
      getCentreUsers(`?${url}`);
    }
    setPage(newPage as number);
  };

  useEffect(() => {
    getCenterInfo();
    getCentreUsers();
  }, []);

  const verifyMobile = (type: any) => {
    const mobileRegEx = /^[6-9]\d{9}$/;

    if (
      type === "contMob" &&
      phoneNo &&
      !mobileRegEx.test(phoneNo.toString())
    ) {
      setMobileValidation((prev: any) => ({
        ...prev,
        phoneNo: false,
      }));
    } else if (
      type === "contMob" &&
      phoneNo &&
      mobileRegEx.test(phoneNo.toString())
    ) {
      setMobileValidation((prev: any) => ({
        ...prev,
        phoneNo: true,
      }));
    }
  };
  useEffect(() => {
    getCentreUsers(`?id=${centre}`);
  }, [centre]);

  const handleSave = async (e: any) => {
    e.preventDefault();
    const data = {
      phonenumber: phoneNo,
      usergroup: "CCPartner",
      email: email,
      name: name,
      empid: empId,
      center_rights: String(centre),
    };
    if (empId === "") {
      delete data.empid;
    }
    await createUsers(data);
    history.push("/dashboard/gnadmin/create-users");
  };

  return (
    <Grid container spacing={2} style={{ marginTop: 50 }}>
      <h2>Create Users</h2>
      <form style={{ width: "100%" }} onSubmit={handleSave}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={2}>
            <Autocomplete
              id="center"
              onChange={(event, newValue) => {
                if (newValue) {
                  let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                  setCentre(obj.id);
                }
              }}
              freeSolo
              blurOnSelect
              options={centerInfo?.results || []}
              disableCloseOnSelect
              getOptionLabel={(option: any) =>
                (option?.display_name === null
                  ? option?.name
                  : option?.display_name) +
                "(" +
                option?.center_code +
                ")"
              }
              onInputChange={(event, newInputValue) => {
                getCenterInfo(`?name_or_code=${newInputValue}`);
                setCentreName(newInputValue);
              }}
              inputValue={centreName}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Hospital/Doctor"
                  variant="outlined"
                  fullWidth
                  required
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <TextField
              label="Emp. ID"
              variant="outlined"
              fullWidth
              value={empId}
              onChange={(e) => setEmpId(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <TextField
              label="Name"
              variant="outlined"
              fullWidth
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <TextField
              label="Email"
              type="email"
              variant="outlined"
              fullWidth
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <TextField
              className="input"
              name="contact"
              type="number"
              label="Phone Number"
              value={phoneNo}
              variant="outlined"
              style={{ margin: "0", width: "100%" }}
              onChange={(e) => setPhoneNo(e.target.value)}
              required
              onBlur={() => verifyMobile("contMob")}
              onFocus={() => {
                setMobileValidation((prev: any) => ({
                  ...prev,
                  centerHeadalContactNumber: true,
                }));
              }}
              onWheel={(e: any) => e.target.blur()}
              onInput={(e: any) => {
                e.target.value = Math.max(0, parseInt(e.target.value))
                  .toString()
                  .slice(0, 10);
              }}
              helperText={
                mobileValidation.phoneNo === false
                  ? "Incorrect Mobile Number"
                  : ""
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Button
              color="secondary"
              variant="contained"
              fullWidth
              disabled={mobileValidation.phoneNo === false}
              type="submit"
              style={{ height: "100%" }}
            >
              save
            </Button>
          </Grid>
        </Grid>
      </form>

      <Grid container style={{ marginTop: 10 }}>
        <TableContainer
          className={classes.tableContainer}
          component={Paper}
          style={{ maxHeight: "540px" }}
        >
          {loading ? (
            <Loader />
          ) : (
            <Table stickyHeader aria-label="simple table">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell align="center">S. No.</StyledTableCell>
                  <StyledTableCell align="center">Hospital/Doctor Name</StyledTableCell>
                  <StyledTableCell align="center">
                    Employee Details
                    <div style={{ width: "100%", display: "flex" }}>
                      <div style={{ width: "33%", border: "1px solid #fff" }}>
                        Name
                      </div>
                      <div style={{ width: "33%", border: "1px solid #fff" }}>
                        Email
                      </div>
                      <div style={{ width: "33%", border: "1px solid #fff" }}>
                        Phone
                      </div>
                    </div>
                  </StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {centreUsersData &&
                  centreUsersData.results &&
                  centreUsersData.results?.length > 0 &&
                  centreUsersData.results?.map((row: any, index: number) => {
                    return (
                      <StyledTableRow key={index}>
                        <StyledTableCell align="center">
                          {index + 1}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row?.display_name === null
                            ? row?.name
                            : row?.display_name}
                        </StyledTableCell>

                        <StyledTableCell align="center">
                          {row &&
                            row.asigned?.length > 0 &&
                            row.asigned?.map((val: any) => {
                              return (
                                <div style={{ width: "100%", display: "flex" }}>
                                  <div
                                    style={{
                                      width: "33%",
                                      border: "1px solid grey",
                                      padding: 3,
                                    }}
                                  >
                                    {val?.fullname}
                                  </div>
                                  <div
                                    style={{
                                      width: "33%",
                                      border: "1px solid grey",
                                      padding: 3,
                                    }}
                                  >
                                    {val?.email}
                                  </div>
                                  <div
                                    style={{
                                      width: "33%",
                                      border: "1px solid grey",
                                      padding: 3,
                                    }}
                                  >
                                    {val?.phone}
                                  </div>
                                </div>
                                // <tr>
                                //   <td
                                //     align="center"
                                //     style={{ border: "1px solid grey" }}
                                //   >
                                //     {val}
                                //   </td>
                                // </tr>
                              );
                            })}
                        </StyledTableCell>
                      </StyledTableRow>
                    );
                  })}
              </TableBody>
              <TableFooter>
                <TablePagination
                  rowsPerPageOptions={[]}
                  colSpan={3}
                  count={centreUsersData.count}
                  rowsPerPage={centreUsersData.page_size}
                  page={page}
                  onPageChange={handleChangePage}
                />
              </TableFooter>
            </Table>
          )}
        </TableContainer>
      </Grid>
    </Grid>
  );
};
const mapStateToProps = (state: any) => ({
  centerInfo: state.GenomicsAdminReducer.centerInfo,
  centreUsersData: state.GenomicsAdminReducer.centreUsersData,
  loading: state.GenomicsAdminReducer.loading,
});
export default connect(mapStateToProps, {
  getCenterInfo,
  getCentreUsers,
  createUsers,
})(CreateUsers);
